import {
  TEMPLATE_GROUP_ASSET_DRIVEN,
  TEMPLATE_GROUP_TEMPLATES,
} from '~/constants/template';

export const COMBO_NOGROUP = 'nogroup';

/**
 * Sort Combolist groups so Asset-Driven appears before Templates,
 * ungrouped items last, and remaining groups alphabetically.
 */
export function compareCombolistGroups(groupA: string, groupB: string): number {
  if (groupA === COMBO_NOGROUP) return 1;
  if (groupB === COMBO_NOGROUP) return -1;
  if (
    groupA === TEMPLATE_GROUP_ASSET_DRIVEN &&
    groupB === TEMPLATE_GROUP_TEMPLATES
  ) {
    return -1;
  }
  if (
    groupA === TEMPLATE_GROUP_TEMPLATES &&
    groupB === TEMPLATE_GROUP_ASSET_DRIVEN
  ) {
    return 1;
  }
  return groupA.localeCompare(groupB);
}
